// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"95d706f7","879":"d4aa8fe6","977":"0ef9b555"}[chunkId] + ".chunk.js";
};